import React from 'react';

// eslint-disable-next-line react/require-default-props
export const Icons24BolderInfoCircle = ({ className = '' }: { className?: string }): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <g fill='#009EAD' className={className}>
        <g>
          <g>
            <path
              d='M12 8c-.827 0-1.5-.673-1.5-1.5S11.173 5 12 5s1.5.673 1.5 1.5S12.827 8 12 8zm1.5 8.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v5zM12 2C6.478 2 2 6.477 2 12s4.478 10 10 10 10-4.477 10-10S17.522 2 12 2z'
              transform='translate(-878 -637) translate(878 637)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
